<button
  mat-button
  data-cy="create-offer-btn"
  class="create-offer-btn"
  color="primary"
  (click)="handleCreate()">
  Add Offer
</button>
